import { useCallback } from 'react';
import RequestRabbit from './RequestRabbit';

const useCampaignRequest = () => {
  const getOptions = useCallback(async (names, errorHandler) => {
    try {
      return await RequestRabbit.get(
        '/admin/campaign-management/options',
        { names },
        errorHandler
      );
    } catch (e) {
      errorHandler(e.message);
    }
  }, []);

  return {
    getOptions,
  };
};

export default useCampaignRequest;
